<template>
  <q-separator class="q-ma-xs" />
  <q-expansion-item
    :class="$q.dark.mode == false ? 'bg-pink-1 text-bold' : 'bg-grey-9 '"
  >
    <template v-slot:header>
      <q-item-section> Portfolio Zone </q-item-section>
    </template>
    <q-item
      v-for="link in portfolioZone"
      :key="link.text"
      v-ripple
      clickable
      :class="
        $q.dark.mode == false
          ? ' menu-item bg-white text-weight-regular bg-white text-bold'
          : ' menu-item bg-white text-weight-regular bg-grey-9 '
      "
      @click="link.url ? openURL(link.url) : $router.push({ name: link.name })"
    >
      <!-- <q-item-section> -->
      <q-icon
        v-if="link.text !== 'Web Meroworth'"
        color="grey"
        size="sm"
        :name="link.icon"
      />
      <q-img
        style="width: 20px; height: 20px; margin-top: 5px"
        size="sm"
        v-if="link.text == 'Web Meroworth'"
        :src="
          $q.dark.mode === true
            ? 'images/meroworthWhitelogo.svg'
            : 'images/meroworthlogo.svg'
        "
      />
      <!-- </q-item-section> -->
      <q-item-section style="margin-left: 16px">
        <q-item-label>
          {{ link.text }}
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-expansion-item>
</template>

<script setup>
const props = defineProps({
  portfolioZone: Array,
});
const openURL = (link) => {
  window.open(link);
};
</script>
